import { Media } from "@app/shared/models/media";
export class Product {
  id?: number;
  code?:string;
  descr?:string;
  gtin?:string;
  supplier?:string;
  uuid?:string;
  productassets:any[];
  media:Media[];
  heroMediaURL?:string;
  hero?:string;
  // get heroMedia():Media{
  //   let media:Media;
  //   media.thumbUrl = this.heroMediaURL;
  //   // if(this.productassets && this.productassets.length)
  //   //   media = this.productassets[0];
  //   return media;
  // }
}

export class ProductMenuEvent{
  type?:string;
  product?:Product;
}

export const ProductMenuEventType = {
  EDIT_PRODUCT: 'EDIT_PRODUCT',
  ADD_PRODUCT: 'ADD_PRODUCT',
  LOCK_PRODUCT:'LOCK_PRODUCT',
  DELETE_PRODUCT:'DELETE_PRODUCT',
  ADD_TO_FAVE:'ADD_TO_FAVE',
  ALLOC_PRODUCT:'ALLOC_PRODUCT',
  COPY_PRODUCT:'COPY_PRODUCT',
  PRODUCT_HISTORY:'PRODUCT_HISTORY',
};

export class ProductSearchCriteria{
  keyword?:string;
  includeAssets?:boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/product.ts